const initialState = {
  uploadResponses: {},
  uploadErrors: {},
};

const uploadImageReducer = (state = initialState, action) => {
  switch (action.type) {
    case "UPLOAD_IMAGE_SUCCESS":
      return {
        ...state,
        uploadResponses: {
          ...state.uploadResponses,
          [action.payload.uploadKey]: action.payload.file,
        },
      };
    case "UPLOAD_IMAGE_FAILURE":
      return {
        ...state,
        uploadErrors: {
          ...state.uploadErrors,
          [action.payload.uploadKey]: action.payload.error,
        },
      };
    default:
      return state;
  }
};

export default uploadImageReducer;
